/**
 * Dawn theme — move sold-out products to the end of the collection grid.
 * Runs client-side after the grid renders. Doesn't touch Liquid,
 * doesn't remove/duplicate any product, just reorders existing DOM nodes.
 */
(function () {
  function sortSoldOutToEnd() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.tagName === 'LI';
    });
    if (items.length < 2) return;

    var inStock = [];
    var soldOut = [];

    items.forEach(function (item) {
      // Dawn shows a "Sold out" badge on unavailable products.
      // If your store uses a different language, add that text below too.
      var badge = item.querySelector('.card__badge span, .badge');
      var text = badge ? badge.textContent.trim().toLowerCase() : '';
      var soldOutLabels = ['sold out']; // add translated labels here if needed

      if (badge && soldOutLabels.indexOf(text) !== -1) {
        soldOut.push(item);
      } else {
        inStock.push(item);
      }
    });

    if (soldOut.length === 0) return;

    var fragment = document.createDocumentFragment();
    inStock.concat(soldOut).forEach(function (item) {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortSoldOutToEnd);
  } else {
    sortSoldOutToEnd();
  }
})();